// extracted by mini-css-extract-plugin
export default {"chosenRow":"Services_chosenRow__RI0uU","selectedServicesTable":"Services_selectedServicesTable__PY965"};